module.exports = "<md-autocomplete md-delay=50 md-no-cache md-autoselect md-select-on-match md-search-text=$ctrl.query md-search-text-change=$ctrl.queryChanged() md-selected-item=$ctrl.selectedItem md-selected-item-change=$ctrl.itemSelected(item) md-items=\"item in $ctrl.search()\" md-item-text=$ctrl.getText(item) md-min-length=1 placeholder=\"{{ $ctrl.placeholder }}\"> <md-item-template> <span md-highlight-text=$ctrl.query md-highlight-flags=^i>{{$ctrl.getText(item)}}</span> </md-item-template> </md-autocomplete>";


//////////////////
// WEBPACK FOOTER
// ./app/common/search-autocomplete/autocomplete.html
// module id = 5m0o
// module chunks = 1